export default __webpack_public_path__ + "static/media/email.f5bb6a36.svg";